export default "__VITE_ASSET__ee7860f1__"